






























































import Component from 'vue-class-component';
import Vue from 'vue';
import * as moment from 'moment';
import { namespace } from 'vuex-class';
import ChoiceSelect from '../components/ChoiceSelect.vue';

const auth = namespace('Auth');
const choice = namespace('Choice');
const vote = namespace('Vote');

@Component({
  components: {
    ChoiceSelect
  }
})
export default class Vote extends Vue {
  @auth.State currentUser!: any;

  @choice.State loadingChoices: boolean;
  @choice.State choices: any[];
  @choice.Action getChoices!: () => void

  @vote.State errorMessage!: string;
  @vote.State submitting!: boolean;
  @vote.State submitted!: boolean;
  @vote.State lastSaved!: moment.Moment;
  @vote.Getter getVote!: (voteRank: number) => number
  @vote.Action vote!: (payload: { voteRank: number, userId: number }) => void
  @vote.Action submit!: () => void;
  @vote.Action getPreviousVotes!: () => void;

  votingCounts = false;
  multiplier = 0;
  countryCode = 'MY';
  countryRankLimit = 1000;

  // Votes
  first = null;
  second = null;
  third = null;
  fourth = null;
  fifth = null;
  sixth = null;
  seventh = null;
  eight = null;
  ninth = null;
  tenth = null;

  filteredChoices(slot: number) {
    const votesArray = [this.first, this.second, this.third, this.fourth, this.fifth, this.sixth, this.seventh, this.eight, this.ninth, this.tenth].splice(slot, 1);
    return this.choices.filter(e => votesArray.indexOf(e.id) === -1);
  }

  mounted() {
    this.getChoices();
    this.getPreviousVotes();
    this.setMultiplierAndAbilityToVote();

    this.$store.subscribe(action => {
      if (action.type === 'Vote/setErrorMessage' && action.payload) {
        // Scroll to error
        setTimeout(() => {
          this.$vuetify.goTo('#error', { offset: 100 });
        }, 100);
      }

      if (action.type === 'Vote/setSubmitted' && action.payload) {
        // Success
        setTimeout(() => {
          this.$vuetify.goTo('#success', { offset: 100 });
        }, 100);
      }
    });
  }

  setMultiplierAndAbilityToVote() {
    this.votingCounts = this.currentUser.country === this.countryCode && this.currentUser.countryRank <= this.countryRankLimit;
    if (this.votingCounts) {
      if (this.currentUser.countryRank >= 1 && this.currentUser.countryRank <= 10) {
        this.multiplier = 5;
      }

      if (this.currentUser.countryRank >= 11 && this.currentUser.countryRank <= 25) {
        this.multiplier = 4;
      }

      if (this.currentUser.countryRank >= 26 && this.currentUser.countryRank <= 50) {
        this.multiplier = 3;
      }

      if (this.currentUser.countryRank >= 51 && this.currentUser.countryRank <= 100) {
        this.multiplier = 2;
      }

      if (this.currentUser.countryRank >= 101) {
        this.multiplier = 1;
      }
    }
  }

  selectChoice(userId: number, voteRank: number) {
    this.vote({ voteRank, userId });
  }
}
